<template>
  <header class="header-component">
    <dx-toolbar class="header-toolbar" :ref="'toolBarContent'">
      <!-- v-bind:class="[tabs.length != 0 && !isXSmall ? 'header-toolbar-with-tabs' : 'header-toolbar-no-tabs']" -->
      <dx-item
        :visible="menuToggleEnabled"
        location="before"
        css-class="menu-button"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <dx-button styling-mode="text" @click="toggleMenuFunc" slot-scope="_" />
        <!--icon="menu" -->
        <!-- eslint-enable -->
      </dx-item>
      <dx-item
        :visible="backButtonEnabled"
        location="before"
        css-class="menu-button back-button"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <dx-button
          icon="arrowleft"
          styling-mode="text"
          @click="performBackFunction"
          slot-scope="_"
          :visible="backButtonEnabled"
        />
        <!-- eslint-enable -->
      </dx-item>
      <dx-item location="before" css-class="header-right-content">
        <div slot-scope="_">
          <!-- eslint-enable -->
          <gc-header-right
            :showTabs="showTabs"
            :options="tabOptions"
            :selectedIndex="selectedIndex"
          >
            <slot name="headerContent" />
          </gc-header-right>
        </div>
      </dx-item>

      <dx-item
        :visible="profileMenuEnabled"
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <div slot-scope="_">
          <span v-if="companyNameVisibleInToolbar">
            {{ companyName }}
          </span>
        </div>
      </dx-item>

      <dx-item
        :visible="profileMenuEnabled"
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <div slot-scope="_">
          <!-- eslint-enable -->
          <dx-button
            class="user-button authorization"
            height="100%"
            styling-mode="text"
          >
            <gc-user-panel
              :menu-items="userMenuItems"
              :isXSmall="isXSmall"
              menu-mode="context"
            />
          </dx-button>
        </div>
      </dx-item>
      <!-- eslint-disable vue/no-unused-vars -->
      <gc-user-panel
        :visible="profileMenuEnabled"
        :menu-items="userMenuItems"
        menu-mode="list"
        slot-scope="_"
        slot="menuUserItem"
      />
      <!-- eslint-enable -->
    </dx-toolbar>
    <gc-popup
      :popup-visible="changePasswordPopupVisible"
      :popup-title="changePasswordPopupConfig.title"
      :back-button-function="changePasswordPopUpBackButtonClick"
      :popupHeight="'auto'"
      v-if="changePasswordPopupConfig && changePasswordPopupVisible"
      :saveValidation="passwordChangePopupFormOptions"
      :saveButtonConfig="changePasswordPopupConfig.save"
      :backButtonConfig="changePasswordPopupConfig.back"
      :data-model="changePasswordPopupConfig.dataModel"
      :popupWidth="
        changePasswordPopupConfig.width
          ? changePasswordPopupConfig.width
          : undefined
      "
    >
      <gc-form
        :formOptions="changePasswordPopupConfig.formOptions"
        :formItems="changePasswordPopupConfig.items"
        :formHeight="
          changePasswordPopupConfig.height
            ? changePasswordPopupConfig.height
            : 'auto'
        "
        :isNormal="true"
        :data-model="changePasswordPopupConfig.dataModel"
        :formMode="'create'"
        :validationGroup="'changePasswordPopupConfig-gc-popup-form-data'"
        :formTitle="'gc-popup'"
        v-if="changePasswordPopupConfig.items && changePasswordPopupVisible"
        :valueChangeCallBack="changePasswordPopupConfigValueChangeCallBack"
        :checkValid="passwordChangePopupIsValid"
      ></gc-form>
    </gc-popup>
    <GcPopupValidationSummary
      :showPopup.sync="validationSummaryVisible"
      :title="
        validationItems.length > 0 ? 'Validation Errors' : 'Server Errors'
      "
      :isXSmall="isXSmall"
      :items="
        validationItems.length > 0 ? validationItems : serverValidationItems
      "
    ></GcPopupValidationSummary>

    <GcPopupVersionUpdate
      :callBack="versionUpdateCallBack"
      :setVisible="visibleVersionUpdate"
    />
  </header>
</template>

<script>
// import auth from "../auth";

import "../app.version";
import GcUserPanel from "./gc-user-panel";
import GcHeaderRight from "./gc-header-right";
// import { TokenStorage } from "../_services/storage";
import { authComputed } from "../_store/helpers";
import { mapGetters } from "vuex";
import BrowserHelper from "../_helpers/browser/browser-helper";
import { FeatureStorage } from "@/_services/storage";
import { UserService } from "../_services/api/settings/user/user.service";

import GcPopupVersionUpdate from "../popups/gc-popup-version-update.vue";
import { CommonStorage } from "../_services/storage";

let browserHelper = new BrowserHelper();

export default {
  props: {
    isXSmall: Boolean,
    isLarge: Boolean,
    menuToggleEnabled: Boolean,
    backButtonEnabled: {
      type: Boolean,
      default: false,
    },
    profileMenuEnabled: {
      type: Boolean,
      default: true,
    },
    title: String,
    toggleMenuFunc: {
      type: Function,
      default: function () {},
    },
    backButtonFunc: {
      type: Function,
      default: function () {},
    },
    logOutFunc: Function,
    baseView: Object, // this is available through the mixin
    selectedIndex: Number, // this is available through the mixin
    tabs: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    baseView: function (newVal, oldVal) {},
    getApiVersionUpdate(value) {
      if (value) this.visibleVersionUpdate = true;
    },
    getUiVersionUpdate(value) {
      if (value) this.visibleVersionUpdate = true;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.setApplicationMode(this.applicationMode);
    this.setCurrenUser();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...authComputed,
    ...mapGetters({
      applicationMode: "profile/applicationMode",
      companyName: "profile/companyName",
    }),
    companyNameVisibleInToolbar() {
      return !this.isXSmall;
    },
    showTabs() {
      return this.tabs.length > 0;
    },
    changePasswordPopupConfig() {
      return {
        title: "Change Password",
        // gcPopupVisible: this.gcPopupVisible,
        height: 250,
        save: {
          text: "Save",
          disabled: this.ischangePasswordPopupConfigSaveDisabled(),
          clickCallback: async () => {
            await this.savePasswordChange();
          },
        },
        back: {
          text: "Cancel",
          clickCallback: async () => {
            //  if (this.CellValueChanged) {
            let confirmLeaving = await this.$confirm(
              "You have unsaved changes. Are you sure you want to leave ?",
              "Unsaved Changes"
            );

            if (confirmLeaving) {
              this.changePasswordPopUpBackButtonClick();
            }
            // }
          },
        },
        dataModel: this.changePasswordPopupDataModel,
        // width: 100,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "PayeeName",
                    dataField: "Username",
                    required: true,
                    label: {
                      text: "Username",
                    },
                    editorOptions: {
                      allowUpdate: false,
                    },
                  },
                  {
                    screenField: "PayeeName",
                    dataField: "CurrentPassword",
                    required: true,
                    editorOptions: { mode: "password", allowUpdate: true },
                    label: {
                      text: "Current Password",
                    },
                  },
                  {
                    screenField: "PayeeName",
                    dataField: "NewPassword",
                    editorOptions: { mode: "password", allowUpdate: true },
                    required: true,
                    label: {
                      text: "New Password",
                    },
                    // editorOptions: {
                    //   allowUpdate: true,
                    // },
                  },
                  {
                    screenField: "PayeeName",
                    dataField: "RetypePassword",
                    editorOptions: { mode: "password", allowUpdate: true },
                    required: true,
                    label: {
                      text: "Retype New Password",
                    },
                    validationRules: [
                      {
                        type: "custom",

                        validationCallback: ({ value, rule }) => {
                          rule.message = `The New password and Retype new password do not match`;
                          return (
                            value ===
                            this.changePasswordPopupConfig.dataModel.NewPassword
                          );
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        // height: 100,
      };
    },
    visibleTabs() {
      let tabs = this.tabs;
      tabs.forEach((x) => {
        if (
          !FeatureStorage.checkPermission(x.applicationFeatureCode, "review")
        ) {
          x.visible = false;
        }
      });

      return tabs;
    },
    tabOptions() {
      return {
        dataSource: this.visibleTabs,
        onItemClick: this.itemClick,
        onOptionChanged: this.onOptionChanged,
        selectedIndex: this.selectedIndex,
        showNavButtons: true,
        scrollByContent: true,
        width: this.isXSmall ? this.calculatedTabWidth + "px" : "auto",
        visible: this.isMobileMode
          ? true
          : this.applicationMode == "GcorpRoam"
          ? false
          : true,
      };
    },
    userMenuItems() {
      let result = this.menuItems;

      if (this.isXSmall) {
        result = this.menuItems
          .slice(0)
          .filter((x) => x.group !== "GcorpRoamOnly");
        result.unshift({
          text: this.currentUser,
          icon: "",
        });
      }

      return result;
    },

    menuItems() {
      return this.menuItemData;
    },
    ...mapGetters({ getApiVersionUpdate: "ui/getApiVersionUpdate" }),
    ...mapGetters({ getUiVersionUpdate: "ui/getUiVersionUpdate" }),
    ...mapGetters({ getAPIVersion: "ui/getAPIVersion" }),
    ...mapGetters({ getUIVersion: "ui/getUIVersion" }),
    menuItemData() {
      return [
        // {
        //   text: this.companyName, // company name
        //   icon: "",
        // },
        {
          template: "separator",
        },
        {
          text: "Menu",
          group: "GcorpRoamOnly",
        },
        {
          text: "Gcorp",
          icon: "check",
          onClick: this.onGcorpMenuClick,
          name: "menuGcorp",
          group: "GcorpRoamOnly",
        },
        {
          text: "Gcorp Roam",
          icon: "noicon",
          onClick: this.onGcorpRoamMenuClick,
          name: "menuGcorpRoam",
          group: "GcorpRoamOnly",
        },
        {
          text: "Change Password",
          icon: "noicon",
          onClick: this.onChangePasswordClick,
          name: "menuGcorpRoam",
          group: "GcorpRoamOnly",
        },
        {
          template: "separator",
          group: "GcorpRoamOnly",
        },
        {
          text: "Version Information",
          icon: "info",
          name: "VersionInformation",
          group: "GcorpRoamOnly",
          visible:
            this.getUIVersion != undefined || this.getAPIVersion != undefined,
          cssClass: "icon-menu",
        },
        {
          text: "UI : " + this.getUIVersion,
          icon: "noicon",
          name: "UIVersion",
          visible: this.getUIVersion != undefined,
        },
        {
          text: "API : " + this.getAPIVersion,
          icon: "noicon",
          name: "APIVersion",
          visible: this.getAPIVersion != undefined,
        },
        {
          template: "separator",
          group: "GcorpRoamOnly",
        },
        {
          text: "Help",
          icon: "help",
          onClick: this.gotoHelpPage,
          name: "menuGcorpRoam",
          group: "GcorpRoamOnly",
        },
        {
          template: "separator",
          group: "GcorpRoamOnly",
        },
        {
          text: "Logout",
          icon: "runner",
          onClick: this.onLogoutClick,
        },
      ];
    },
  },

  data() {
    return {
      changePasswordPopupDataModel: {
        Username: undefined,
        CurrentPassword: undefined,
        NewPassword: undefined,
        RetypePassword: undefined,
      },
      validationSummaryVisible: false,
      validationItems: [],
      serverValidationItems: [],
      passwordChangePopupIsValid: false,
      changePasswordPopupVisible: false,
      calculatedTabWidth: window.innerWidth - 100,
      isMobileMode: browserHelper.mobile,
      setCompanyName: null,
      // gcPopupVisible: false,
      // menuItemData: ,
      previousValueIndex: undefined,
      visibleVersionUpdate: false,
    };
  },
  methods: {
    versionUpdateCallBack(value) {
      this.visibleVersionUpdate = false;
      const broadcastChannel = new BroadcastChannel("session-channel");
      this.$store.dispatch("ui/apiVersionUpdate", false);
      this.$store.dispatch("ui/uiVersionUpdate", false);

      if (value == true) {
        broadcastChannel.postMessage({
          action: "version_logout",
        });
      } else {
        let getVersionTimeOutReminder = CommonStorage.getItems(
          "VersionCheckerReminderInMinutes"
        );

        if (getVersionTimeOutReminder == undefined)
          getVersionTimeOutReminder = 360;

        CommonStorage.saveItems(
          "VersionCheckerTimerInMinutes",
          getVersionTimeOutReminder
        );
        broadcastChannel.postMessage({
          action: "version_interval",
          value: getVersionTimeOutReminder * 60 * 1000,
        });
      }
    },
    gotoHelpPage() {
      this.$router.push({
        path: "/help",
      });
    },
    ischangePasswordPopupConfigSaveDisabled() {
      let { CurrentPassword, NewPassword, RetypePassword } =
        this.changePasswordPopupDataModel;
      return (
        !CurrentPassword ||
        CurrentPassword == "" ||
        !NewPassword ||
        NewPassword == "" ||
        !RetypePassword ||
        RetypePassword == "" ||
        NewPassword != RetypePassword
      );
    },
    setCurrenUser() {
      this.changePasswordPopupDataModel.Username = this.currentUser;
    },
    addToValidation(obj) {
      this.validationSummary = [];
      this.validationSummary.push(obj);
    },
    displayServerError(error, genericMessage) {
      this.$logger.debug("error", error);
      this.serverValidationItems = [];
      if (error.data.error.innererror) {
        this.serverValidationItems.push(error.data.error.innererror.message);
      } else if (error.data.error.message) {
        var item = undefined;
        if (JSON.parse(error.data.error.message)[0].MemberNames.length > 0) {
          var memberNames = JSON.parse(error.data.error.message)[0].MemberNames;
          if (memberNames[0])
            item =
              memberNames[0] +
              " " +
              JSON.parse(error.data.error.message)[0].ErrorMessage;
        }

        if (!item) item = JSON.parse(error.data.error.message)[0].ErrorMessage;

        this.serverValidationItems.push(item);
      } else {
        this.$notify(genericMessage, "error");
      }

      this.validationSummaryVisible = true;
    },
    async savePasswordChange() {
      let { CurrentPassword, NewPassword, Username } =
        this.changePasswordPopupDataModel;
      var payload = {
        CurrentPassword: CurrentPassword,
        NewPassword: NewPassword,
        Username: Username,
      };
      await UserService.changeUserPassword(payload)
        .then(() => {
          this.$notify(`The password has been successfully changed`, "success");
          this.changePasswordPopupVisible = false;
          this.onLogoutClick();
        })
        .catch((err) => {
          this.setLoading = false;
          this.displayServerError(err, "Password change failed.");
        });
    },
    validationSummary(itemArray) {
      this.validationItems = [];
      if (itemArray)
        itemArray.forEach((x) => {
          this.validationItems.push(x.message);
        });
      this.validationSummaryVisible = true;
    },
    changePasswordPopupConfigValueChangeCallBack(isValid, brokenRules) {
      this.passwordChangePopupIsValid = false;
      if (!isValid) this.validationSummary(brokenRules);
      else {
        this.changePasswordPopupConfig.save.clickCallback();
        // this.gcPopupConfig.dataModel
        //   ? this.gcPopupConfig.dataModel
        //   : this.transactionData
      }
    },
    passwordChangePopupFormOptions() {
      this.passwordChangePopupIsValid = true;
    },
    changePasswordPopUpBackButtonClick() {
      this.changePasswordPopupDataModel = {
        Username: this.currentUser,
        CurrentPassword: undefined,
        NewPassword: undefined,
        RetypePassword: undefined,
      };
      this.changePasswordPopupVisible = false;
    },
    performBackFunction() {
      this.$logger.trackEventButtonClickBack();
      this.backButtonFunc();
    },
    onLogoutClick() {
      this.$logger.trackEventButtonClick("Logout");
      this.$store.dispatch("authentication/logout");
    },
    onGcorpMenuClick() {
      this.setApplicationMode("Gcorp");
      this.$store.dispatch("profile/setApplicationMode", "Gcorp");
    },
    onGcorpRoamMenuClick() {
      this.setApplicationMode("GcorpRoam");
      this.$store.dispatch("profile/setApplicationMode", "GcorpRoam");
    },
    onChangePasswordClick() {
      this.cellValueChanged = true;
      this.changePasswordPopupVisible = true;
    },
    setApplicationMode(mode) {
      if (mode.replace(/[^a-zA-Z ]/g, "") == "Gcorp") {
        let menuGcorp = this.menuItems.find((x) => x.name == "menuGcorp");
        menuGcorp.icon = "check";
        let menuGcorpRoam = this.menuItems.find(
          (x) => x.name == "menuGcorpRoam"
        );
        menuGcorpRoam.icon = "noicon";
      } else {
        let menuGcorp = this.menuItems.find((x) => x.name == "menuGcorp");
        menuGcorp.icon = "noicon";
        let menuGcorpRoam = this.menuItems.find(
          (x) => x.name == "menuGcorpRoam"
        );
        menuGcorpRoam.icon = "check";
      }
    },
    onOptionChanged(e) {
      if (e.fullName == "selectedIndex") {
        this.previousValueIndex = e.previousValue;
      }
    },
    async itemClick(e) {
      if (e.itemData.path == "") {
        return;
      }

      // eslint-disable-next-line no-debugger

      if (this.$router.currentRoute.fullPath == e.itemData.path) return;
      //   this.$router.push({
      //     path: e.itemData.path,
      //   });

      if (
        !e.itemData.ignoreRouteChange &&
        (this.baseView.mode == "create" || this.baseView.mode == "edit") &&
        !(browserHelper.mobile || browserHelper.tablet)
      ) {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          this.isLeaving = true;
          this.$store.dispatch("dataContext/setDataViewType", undefined);

          this.$store.dispatch("ui/setIgnoreRouteChange", true);
          this.$router
            .push({
              path: e.itemData.path,
            })
            .then(() => {
              if (e.itemData.onClick) e.itemData.onClick(e);
            });
        } else {
          e.component.beginUpdate();
          e.component.option("selectedIndex", this.previousValueIndex);
          e.component.endUpdate();
        }
      } else {
        this.$router
          .push({
            path: e.itemData.path,
          })
          .then(() => {
            if (
              e.itemData.onClick &&
              typeof e.itemData.onClick === "function"
            ) {
              e.itemData.onClick(e.itemData);
            }
          });
      }
    },
    handleResize(e) {
      if (e != null) {
        // eslint-disable-next-line no-console
        // this.$logger.debug("Resize Event: ", e.srcElement.innerWidth);
        this.calculatedTabWidth = e.srcElement.innerWidth - 100;
      }
      this.$store.dispatch(
        "ui/toolBarHeight",
        this.$refs["toolBarContent"].$el.clientHeight
      );
    },
  },
  mounted() {
    this.handleResize(null);
    this.$store.dispatch("profile/setCompanyName");

    this.menuItemData.unshift({
      text: this.companyName,
      icon: "",
    });
  },

  components: {
    GcUserPanel,
    GcHeaderRight,
    GcPopupVersionUpdate,
  },
};
</script>

<style lang="scss">
@import "../assets/styles/variables.base.scss";
// @import "../v1/assets/styles/global.scss";
@import "@/assets/styles/gc-variables.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 10px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 3px;
  }
}

.header-top {
  padding-left: 5px;
}

.header-toolbar .back-button .dx-icon {
  color: rgb(128, 128, 128) !important;
}

.menu-button .dx-icon-menu {
  display: none !important;
}

.dx-toolbar .dx-toolbar-items-container {
  height: 65px;
}

.header-right .header-top {
  margin-bottom: 0;
}

.header-right .header-bottom {
  margin-bottom: 18px;
}

.header-toolbar .back-button {
  width: 40px !important;
}
.screen-x-small {
  .header-toolbar
    .dx-toolbar-items-container
    .dx-toolbar-before
    .dx-state-invisible.dx-item.dx-toolbar-item.dx-toolbar-button.menu-button.back-button {
    width: 0px !important;
  }
}

.header-top {
  padding-left: 0;
  .text-primary {
    margin-left: 0;
  }
}

.header-toolbar
  .dx-toolbar-items-container
  .dx-toolbar-before
  .dx-state-invisible.dx-item.dx-toolbar-item.dx-toolbar-button.menu-button.back-button {
  display: block !important;
  width: 18px !important;
  .dx-button .dx-button-content {
    display: none;
  }
}

.header-toolbar.header-toolbar-with-tabs {
  .back-button {
    display: block;
    padding-top: 4px !important;
  }
}

#navigation-header
  .dx-toolbar-items-container
  .menu-button
  .dx-button
  .dx-button-content {
  background-image: url("../../public/statics/CX-Favicon.png");
  resize: both;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  margin: auto;
  background-position: center center;
}

.text-primary {
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: normal;
}

.text-secondary {
  font-size: 1rem;
  letter-spacing: normal;
  color: #807878 !important;
}

#navigation-header {
  background-color: #363640 !important;
}

#navigation-header .dx-toolbar-items-container {
  height: 40px !important;
}

.header-toolbar-no-tabs .dx-toolbar-items-container {
  height: 40px !important;
}
</style>
